import { client } from 'laravel-precognition-vue'
import { useCookies } from '@vueuse/integrations/useCookies'
import { updateToken } from '@/utils/auth.ts'

export default function precognitionPlugin () {
  const cookies = useCookies(['authToken'])

  if (cookies.get('authToken')) {
    updateToken(cookies.get('authToken'))
  }

  client.axios().defaults.baseURL = '/api'

  cookies.addChangeListener(options => {
    if (options.name === 'authToken') {
      updateToken(cookies.get('authToken'))
    }
  })
}
